import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/what-if")({
  component: () => <Outlet />,
});